import { xor } from 'lodash';
import { connect } from 'react-redux';
import React, { useCallback } from 'react';
import { ButtonToolbar } from 'react-bootstrap';
import { selectImpactedEntities } from '../../modules/changeImpacts.js';
import StakeholderSearchSelect from '../StakeholderSearchSelect.jsx';

StakeholdersFilter.defaultProps = {
  selectedStakeholdersIds: [],
};

const mapStateToProps = (state, ownProps) => ({
  orgStakeholders: selectImpactedEntities(ownProps.id)(state)
    .impactStakeholders,
});

function StakeholdersFilter({
  selectedStakeholdersIds,
  orgStakeholders,
  navigateAction,
}) {
  const selectedCount = selectedStakeholdersIds.length;

  const handleStakeholderSelect = useCallback(
    (stakeholder) => {
      const stakeholderId = stakeholder.id;
      navigateAction({
        organizationStakeholderIds: xor(selectedStakeholdersIds, [
          stakeholderId,
        ]),
      });
    },
    [selectedStakeholdersIds, navigateAction]
  );

  const handleClearAll = useCallback(() => {
    navigateAction({
      organizationStakeholderIds: [],
    });
  }, [navigateAction]);

  // Convert selectedStakeholdersIds array to object for StakeholderSearchSelect
  const selectedStakeholdersObj = selectedStakeholdersIds.reduce((acc, id) => {
    acc[id] = true;
    return acc;
  }, {});

  const title = selectedCount ? `${selectedCount} Selected` : 'All';

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        Stakeholder Group / Individual
      </div>
      <ButtonToolbar>
        <StakeholderSearchSelect
          stakeholders={orgStakeholders}
          selectedStakeholders={selectedStakeholdersObj}
          onSelectStakeholder={handleStakeholderSelect}
          onClearAll={handleClearAll}
          title={title}
          showArchived
          className="btn-block"
          combined
        />
      </ButtonToolbar>
    </div>
  );
}

export default connect(mapStateToProps)(StakeholdersFilter);
